import React from "react";

import { Presenter } from "./Presenter";

import { Props } from "../../types/Breadcrumb";

export const Breadcrumb: React.VFC<Props> = (props) => {
  return <Presenter {...props} />;
};
